import { IAdminSetting } from '../../../APIPackage/AdminModule/interfaces/IAdminSetting';
import { AdminSettingCodesEnum } from '../../../APIPackage/AdminModule/enums/AdminSettingCodesEnum';
import { KnmSystemTypesEnum } from '../../../KnmPackage/MainModule/enums/KnmSystemTypesEnum';

export const getMaxFileSize = (settings: IAdminSetting[], knmSystemType: KnmSystemTypesEnum | undefined) => {
  const isErp = knmSystemType === KnmSystemTypesEnum.ERP;

  if (isErp) {
    return 5;
  }

  const setting = settings?.find(st => st.code === AdminSettingCodesEnum.MAX_FILE_SIZE_MB);

  return Number(setting?.value);
};
